import { useEffect, useRef, useState } from "react";

export function useCountdown(initialMs: number, interval = 20) {
    const [timeLeft, setTimeLeft] = useState(initialMs);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    const start = () => {
        if (timerRef.current) clearInterval(timerRef.current);

        setTimeLeft(initialMs);
        timerRef.current = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 0) {
                    clearInterval(timerRef.current!);
                    return 0;
                }
                return prev - interval;
            });
        }, interval);
    };

    const reset = () => {
        clearInterval(timerRef.current!);
        setTimeLeft(initialMs);
    };

    const pause = () => {
        if (timerRef.current) clearInterval(timerRef.current);
    };

    const resume = () => {
        start();
    };

    useEffect(() => {
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);

    return [timeLeft, { start, reset, pause, resume }] as const;
}
